// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"loadingSpinner__DI22D","spin":"spin__2Uf1s"};